import React from 'react';
import { Loader2 } from 'lucide-react';

const styles = {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontFamily: 'var(--font-display)',
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    border: '2px solid transparent',
    borderRadius: 'var(--radius-md)',
    cursor: 'pointer',
    transition: 'all var(--transition-fast)',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    position: 'relative',
    overflow: 'hidden',
  },
  sizes: {
    sm: { padding: '8px 14px', fontSize: '0.8rem', minHeight: '40px' },
    md: { padding: '10px 24px', fontSize: '0.875rem', minHeight: '44px' },
    lg: { padding: '14px 32px', fontSize: '1rem', minHeight: '48px' },
  },
  variants: {
    primary: {
      backgroundColor: 'var(--color-primary)',
      color: 'var(--color-bg-primary)',
      borderColor: 'var(--color-primary)',
    },
    secondary: {
      backgroundColor: 'transparent',
      color: 'var(--color-primary)',
      borderColor: 'var(--color-primary)',
    },
    danger: {
      backgroundColor: 'var(--color-danger)',
      color: '#fff',
      borderColor: 'var(--color-danger)',
    },
    ghost: {
      backgroundColor: 'transparent',
      color: 'var(--color-text-secondary)',
      borderColor: 'transparent',
    },
  },
  disabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  onClick,
  type = 'button',
  style: customStyle,
  className,
  ...props
}) {
  const combinedStyle = {
    ...styles.base,
    ...styles.sizes[size],
    ...styles.variants[variant],
    ...(disabled || loading ? styles.disabled : {}),
    ...customStyle,
  };

  return (
    <button
      type={type}
      style={combinedStyle}
      onClick={onClick}
      disabled={disabled || loading}
      className={className}
      onMouseEnter={(e) => {
        if (variant === 'primary') {
          e.target.style.backgroundColor = 'var(--color-primary-light)';
          e.target.style.boxShadow = 'var(--shadow-glow)';
        } else if (variant === 'secondary') {
          e.target.style.backgroundColor = 'var(--color-primary)';
          e.target.style.color = 'var(--color-bg-primary)';
        } else if (variant === 'ghost') {
          e.target.style.color = 'var(--color-text-primary)';
          e.target.style.backgroundColor = 'var(--color-bg-elevated)';
        }
      }}
      onMouseLeave={(e) => {
        const vs = styles.variants[variant];
        e.target.style.backgroundColor = vs.backgroundColor;
        e.target.style.color = vs.color;
        e.target.style.boxShadow = 'none';
      }}
      {...props}
    >
      {loading && <Loader2 size={size === 'sm' ? 14 : 18} style={{ animation: 'spin 1s linear infinite' }} />}
      {children}
    </button>
  );
}
